import useSWR from 'swr';

import { get } from '@/utils/client';

import { GET_DASHBOARD_INVITES } from '@/lib/routes/apiEndpoints';

const useDashboardsInvitations = (options = {}) => {
    const { data, mutate, error } = useSWR(
        GET_DASHBOARD_INVITES,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        invitations: data?.dashboards || undefined,
        total: data?.decideLaterCount + data?.pendingCount || undefined,
        pendingCount: data?.pendingCount || 0,
        mutateInvitations: mutate,
        invitationsError: error,
        isLoading: !data && !error
    };
};

export default useDashboardsInvitations;
